<script>
    import {onMount} from 'svelte';

    import Loader from '../Loader.svelte';
    import { getJWT } from '../../Utilities/Session.svelte';
    import ReportComments from "./ReportComments.svelte"

    import {generateExcelTemplate, auto_size, updateMerges} from '../../lib/report_utils';

    export let assessment;
    export let assessment_model;

    let container;
    let loading = true;
    let spreadsheet;

    let assessment_id;

    let jwt;

    let metadata = {
        type: "cell",
        selected_cell: undefined,
        selected_sheet: undefined,
        cell_text: ""
    };

    async function render() {
        if (!(spreadsheet && $assessment && container)) {
            return;
        }

        if (assessment_id == $assessment.details._id) {
            return
        }

        loading = true;

        let template = $assessment.assessment_type_data.excel_template.template;

        if (!template.length) {
            loading = false;
            return;
        }

        let rendered = await generateExcelTemplate(template, $assessment);

        // auto-size rows
        rendered = await auto_size(JSON.parse(rendered));

        // handle merged cells in templated rows
        rendered = updateMerges(rendered);

        metadata.selected_sheet = rendered[0].name;

        spreadsheet.loadData(rendered);
        assessment_id = $assessment.details._id;
        loading = false;
    }

    $: render($assessment.details, spreadsheet, container);

    onMount(() => {
        getJWT().then((j) => {
            jwt = j

            spreadsheet = new Spreadsheet(container, {
                mode: 'read',
                view: {
                    height: () => container ? container.clientHeight: 0,
                    width: () => container ? container.clientWidth : 0
                },
                showToolbar: false,
                showContextmenu: false
            }).on('cell-selected', setSelectedCell).on("cells-selected", setSelectedCell);
            window.spreadsheet = spreadsheet
        });

        return () => {
            delete window.spreadsheet;
        }
    });

    function setSelectedCell() {
        metadata.selected_sheet = spreadsheet.sheet.data.name;
        metadata.selected_cell = spreadsheet.sheet.data.selector;

        // get sheet index
        let idx = spreadsheet.datas.indexOf(spreadsheet.sheet.data);

        metadata.cell_text = spreadsheet.cell(metadata.selected_cell.ri, metadata.selected_cell.ci, idx)?.text;
    }

    function handleClick(e) {
        if (e.target.className == "active") {
            setSelectedCell()
        }
    }
</script>

<Loader {loading}></Loader>

<div class="columns">
    <div class="column preview" on:click={handleClick}>
        <h1 class="title is-1">
            Preview Excel
        </h1>

        <div bind:this={container}>

        </div>
    </div>
    <div class="column is-3 comments">
        <ReportComments {assessment} {assessment_model} {metadata}></ReportComments>
    </div>
</div>

<style>
    .preview > div {
        height: calc(100vh - 120px);
    }

    .comments {
        display: grid;
        grid-template-rows: min-content minmax(auto, calc(100vh - 285px)) min-content;
    }
</style>